export interface ServiceData {
  slug: string;
  title: string;
  shortTitle: string;
  tagline: string;
  heroDescription: string;
   highlight: boolean;
  heroImage: string;
  heroStats: {
    value: string;
    label: string;
  }[];
  overview: string;
  overviewPoints: string[];
  offerings: {
    title: string;
    description: string;
  }[];
  processSteps: {
    title: string;
    description: string;
  }[];
  whyChooseUs: {
    title: string;
    description: string;
  }[];
  faq: {
    question: string;
    answer: string;
  }[];
  relatedServices: string[];
}

export const services: ServiceData[] = [
    {
    slug: 'commercial-litigation',
    title: 'Commercial Litigation',
    highlight: false,
    shortTitle: 'Commercial Litigation',
    tagline: 'Resolving Business Disputes with Precision',
    heroDescription: 'We provide vigorous representation in commercial and  disputes, combining deep industry knowledge with strategic litigation skills to protect your business interests.',
    heroImage: 'https://images.unsplash.com/flagged/photo-1551135049-83f3419ef05c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVzaW5lc3MlMjBjb250cmFjdCUyMHNpZ25pbmd8ZW58MXx8fHwxNzcxNTY2NjAyfDA&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: '800+', label: 'Disputes Resolved' },
      { value: 'SAR 2B+', label: 'Amount Recovered' },
      { value: '97%', label: 'Win Rate' },
    ],
    overview: 'Business disputes are an inevitable part of commercial life. When they arise, you need advocates who understand both the law and the business context. Our commercial and corporate litigation team brings decades of combined experience before Saudi courts and commercial tribunals, handling everything from breach of contract claims to shareholder disputes and regulatory challenges.',
    overviewPoints: [
      'Breach of contract and commercial agreement disputes',
      'Shareholder and partnership disputes',
      // 'Corporate governance litigation',
      'Real estate and construction disputes',
      // 'Insurance and reinsurance claims',
      // 'Regulatory and administrative appeals',
    ],
    offerings: [
      {
        title: 'Commercial Dispute Resolution',
        description: 'Comprehensive representation in commercial disputes before Saudi courts and tribunals, including claims involving breach of contract and unjust enrichment.',
      },
      {
        title: 'Shareholder Disputes',
        description: 'Advising and representing parties in shareholder conflicts, including minority protection claims, derivative actions, and disputes over company management.',
      },
      {
        title: 'Regulatory Challenges',
        description: 'Contesting adverse regulatory decisions and defending clients against enforcement actions by Saudi regulatory authorities.',
      },
      // {
      //   title: 'Emergency Relief',
      //   description: 'Securing urgent, and safeguard client interests pending final resolution of disputes.',
      // },
    ],
    processSteps: [
      { title: 'Initial Consultation', description: 'We review the facts of your dispute, gather key documents, and provide an honest assessment of your legal position and available remedies.' },
      { title: 'Pre-Litigation Strategy', description: 'Before filing, we explore negotiation and settlement opportunities to resolve the dispute efficiently — saving time and costs where possible.' },
      { title: 'Filing & Court Proceedings', description: 'If litigation is necessary, we prepare and file claims, manage all court appearances, submit evidence, and advocate on your behalf before Saudi commercial courts.' },
      { title: 'Resolution & Execution', description: 'We pursue the best commercial outcome — whether through favorable judgment, negotiated settlement, or enforcement of court orders to protect your interests.' },
    ],
  whyChooseUs: [
  {
    title: 'Court Expertise',
    description: 'Strong experience with Saudi commercial courts and procedures ensures effective and well-prepared advocacy.',
  },
  {
    title: 'Industry Knowledge',
    description: 'We combine legal expertise with sector-specific business understanding for strategic advantage.',
  },
  {
    title: 'Results-Oriented',
    description: 'Our focus is on achieving the best commercial outcome, whether through litigation, negotiation, or settlement.',
  },
  {
    title: 'Responsive Service',
    description: 'We understand the urgency of commercial disputes and respond promptly to protect your interests.',
  },
],
    faq: [
      // {
      //   question: 'How long do commercial litigation cases take in Saudi Arabia?',
      //   answer: 'Timelines vary significantly based on complexity and court workload. Simple cases may resolve in 6-12 months, while complex disputes can take 2-3 years. We focus on efficiency and early resolution strategies where possible.',
      // },
      // {
      //   question: 'Can you handle urgent injunctions?',
      //   answer: 'Yes, our team has significant experience obtaining emergency interim measures and injunctions to protect client interests, including asset freezing orders and specific performance orders.',
      // },
      {
        question: 'Do you offer pre-litigation dispute resolution?',
        answer: 'Absolutely. We always explore negotiation and pre-litigation settlement opportunities before recommending court proceedings, as this often achieves faster and more cost-effective outcomes.',
      },
    ],
    relatedServices: ['international-litigation', 'arbitration', 'debt-recovery'],
  },
    {
    slug: 'debt-recovery',
    title: 'Debt Recovery',
     highlight: false,
    shortTitle: 'Debt Recovery',
    tagline: 'Recovering What Is Rightfully Yours',
    heroDescription: 'Our debt recovery team employs strategic, systematic approaches to recover outstanding debts efficiently, combining legal action with pragmatic commercial negotiation.',
    heroImage: 'https://images.unsplash.com/photo-1574884280706-7342ca3d4231?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkZWJ0JTIwcmVjb3ZlcnklMjBmaW5hbmNlJTIwZG9jdW1lbnRzfGVufDF8fHx8MTc3MTU2NjYwMnww&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: 'SAR 3B+', label: 'Total Recovered' },
      { value: '1,000+', label: 'Cases Managed' },
      { value: '94%', label: 'Recovery Rate' },
    ],
    overview: 'Unpaid debts can significantly impact your business cash flow and viability. Our debt recovery practice provides end-to-end solutions from initial demand through to enforcement of judgments. We understand the Saudi commercial enforcement landscape and employ a combination of legal, regulatory, and commercial strategies to maximize recovery rates for our clients.',
    overviewPoints: [
      'Pre-litigation demand and negotiation',
      'Filing and prosecution of debt claims in Saudi courts',
      'Execution and enforcement of court judgments',
      'Asset tracing and preservation orders',
      'Bankruptcy and insolvency proceedings',
      // 'Cross-border debt recovery coordination',
    ],
    offerings: [
      {
        title: 'Strategic Demand & Negotiation',
        description: 'Professional demand letters and structured negotiation to recover debts without the cost and delay of court proceedings.',
      },
      {
        title: 'Court Proceedings',
        description: 'Filing and prosecuting debt recovery claims before Saudi Execution Courts and Commercial Courts for efficient judgment and enforcement.',
      },
      {
        title: 'Asset Tracing & Preservation',
        description: 'Identifying and securing debtor assets through investigative techniques and protective court orders to ensure recoverability.',
      },
      {
        title: 'Insolvency Proceedings',
        description: 'Advising creditors in bankruptcy and insolvency matters under the Saudi Bankruptcy Law, including proof of claims and distribution proceedings.',
      },
    ],
 processSteps: [
  {
    title: 'Debt Assessment',
    description: 'We review your claim documentation, verify the debt amount, assess the debtor\'s financial position, and evaluate the likelihood and timeline for recovery.',
  },
  {
    title: 'Formal Demand',
    description: 'Our team issues professional demand letters and initiates structured negotiations to recover the debt without resorting to court proceedings.',
  },
  {
    title: 'Legal Proceedings',
    description: 'If negotiation fails, we file and prosecute debt claims before Saudi Commercial Courts and Execution Courts, seeking swift judgment in your favor.',
  },
  {
    title: 'Enforcement',
    description: 'We proceed with court-ordered enforcement actions to support recovery of outstanding debts through available legal mechanisms.',
  },
],
   whyChooseUs: [
  {
    title: 'High Recovery Rates',
    description: 'Our systematic approach and enforcement expertise deliver consistently strong recovery outcomes.',
  },
  {
    title: 'Cost-Effective',
    description: 'We structure our fees to align with your recovery goals, including success-based arrangements.',
  },
  {
    title: 'Enforcement Expertise',
    description: 'Deep experience with Saudi Execution Courts and enforcement procedures ensures effective recovery.',
  },
  {
    title: 'Volume Capability',
    description: 'Systems and processes to handle both individual high-value claims and large portfolios of debts.',
  },
],
   faq: [
  {
    question: 'What is the typical success rate for debt recovery in Saudi Arabia?',
    answer: 'Our success rates depend on the strength of documentation, debtor solvency, and asset availability. We maintain recovery rates significantly above industry averages through our systematic approach and enforcement expertise.',
  },
  {
    question: 'How are your fees structured for debt recovery?',
    answer: 'We offer flexible fee structures including fixed fees and success-based arrangements. We discuss the optimal structure based on the size and nature of your claim.',
  },
],
    relatedServices: ['commercial-corporate-litigation', 'international-litigation', 'arbitration'],
  },

    {
    slug: 'mediation',
    title: 'Mediation',
    highlight: false,
    shortTitle: 'Mediation',
    tagline: 'Finding Common Ground Through Expert Facilitation',
    heroDescription: 'Our mediation practice helps parties resolve disputes efficiently and amicably, preserving business relationships while achieving satisfactory outcomes for all sides.',
    heroImage: 'https://images.unsplash.com/photo-1681505526188-b05e68c77582?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtZWRpYXRpb24lMjBuZWdvdGlhdGlvbiUyMGFncmVlbWVudHxlbnwxfHx8fDE3NzE1NjY2MDR8MA&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: '400+', label: 'Mediations Conducted' },
      { value: '85%', label: 'Settlement Rate' },
      { value: '60%', label: 'Faster Resolution' },
    ],
    overview: 'Mediation offers a confidential, cost-effective, and relationship-preserving alternative to litigation and arbitration. As Saudi Arabia increasingly embraces alternative dispute resolution, mediation has become a powerful tool for resolving commercial disputes. Our mediators are trained professionals who facilitate productive dialogue and creative problem-solving to help parties reach mutually acceptable solutions.',
    overviewPoints: [
      'Commercial and corporate mediation',
      'Construction and infrastructure dispute mediation',
      'Employment and workplace dispute mediation',
      'Real estate and property mediation',
      'Family business and succession mediation',
      'Multi-party and complex dispute mediation',
    ],
    offerings: [
      {
        title: 'Mediation Representation',
        description: 'Representing clients as counsel in mediation proceedings, preparing position statements, and advocating effectively within the mediation framework.',
      },
      {
        title: 'Mediation Services',
        description: 'Providing experienced mediators to facilitate dispute resolution between parties, ensuring a fair and productive process.',
      },
      // {
      //   title: 'Med-Arb Proceedings',
      //   description: 'Managing hybrid mediation-arbitration processes that attempt settlement first before proceeding to binding determination if needed.',
      // },
      {
        title: 'Mediation Clause Design',
        description: 'Incorporating effective mediation provisions into commercial agreements to encourage early and constructive dispute resolution.',
      },
    ],
    processSteps: [
      { title: 'Conflict Assessment', description: 'We evaluate the dispute, understand each party\'s interests and concerns, and assess whether mediation is the right approach for resolution.' },
      { title: 'Mediator Selection & Preparation', description: 'We help select an appropriate mediator, prepare your position statement, gather supporting materials, and develop your negotiation strategy.' },
      { title: 'Mediation Sessions', description: 'Our counsel represents you through joint and private sessions, facilitating productive dialogue and advocating for outcomes that serve your interests.' },
      { title: 'Settlement & Documentation', description: 'When agreement is reached, we draft a comprehensive settlement agreement and arrange for court registration to ensure enforceability.' },
    ],
    whyChooseUs: [
      {
        title: 'Trained Mediators',
        description: 'Our team includes internationally certified mediators with extensive experience in commercial dispute resolution.',
      },
      {
        title: 'High Settlement Rates',
        description: 'Our structured approach to mediation achieves settlement rates significantly above industry averages.',
      },
      {
        title: 'Confidentiality',
        description: 'We ensure strict confidentiality throughout the mediation process, protecting sensitive business information.',
      },
      {
        title: 'Relationship Preservation',
        description: 'Mediation preserves business relationships that litigation would damage, enabling continued commercial cooperation.',
      },
    ],
   faq: [
  {
    question: 'Is a mediated settlement legally binding?',
    answer: 'A mediated settlement agreement, once signed by the parties, is a legally binding contract. It can also be registered with the court for direct enforcement, giving it the same force as a court judgment.',
  },
  {
    question: 'When is mediation appropriate?',
    answer: 'Mediation is suitable for most commercial disputes, particularly when parties wish to preserve their business relationship, maintain confidentiality, or achieve a faster resolution than litigation or arbitration.',
  },
  {
    question: 'What if mediation fails?',
    answer: 'If mediation does not result in settlement, parties retain their full rights to pursue litigation or arbitration.',
  },
],
    relatedServices: ['arbitration', 'commercial-corporate-litigation', 'contract-drafting-&-support'],
  },


   {
    slug: 'arbitration',
    title: 'Arbitration',
     highlight: false,
    shortTitle: 'Arbitration',
    tagline: 'Expert Advocacy in Alternative Dispute Resolution',
    heroDescription: 'Our arbitration team provides world-class representation in domestic and international arbitrations, combining deep procedural expertise with strategic commercial insight.',
    heroImage: 'https://images.unsplash.com/photo-1589307904488-7d60ff29c975?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxhcmJpdHJhdGlvbiUyMGxlZ2FsJTIwZGlzcHV0ZSUyMHJlc29sdXRpb258ZW58MXx8fHwxNzcxNTY2NjA0fDA&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: '300+', label: 'Arbitrations Handled' },
      { value: 'SAR 5B+', label: 'Disputes Valued' },
      { value: '96%', label: 'Favorable Outcomes' },
    ],
    overview: 'Arbitration has become the preferred method of dispute resolution for complex commercial matters in Saudi Arabia, particularly those involving international parties. The Saudi Arbitration Law of 2012, modeled on the UNCITRAL Model Law, has established a modern framework that supports efficient and enforceable arbitration. Our team represents clients in ad hoc and institutional arbitrations under all major rules.',
    overviewPoints: [
      'ICC, LCIA, SIAC, and SCCA arbitrations',
      'Ad hoc arbitrations under UNCITRAL rules',
      'Investor-State arbitrations (ICSID)',
      'Construction and infrastructure disputes',
      'Energy and natural resources arbitrations',
      'Arbitration clause drafting and advisory',
    ],
    offerings: [
      {
        title: 'Arbitration Representation',
        description: 'Full-service representation as counsel in domestic and international arbitrations, from initial case assessment through to award enforcement.',
      },
      {
        title: 'Arbitrator Appointments',
        description: 'Advising on tribunal composition and acting as party-appointed arbitrators in complex commercial disputes.',
      },
      {
        title: 'Award Enforcement',
        description: 'Securing recognition and enforcement of domestic and foreign arbitral awards before Saudi courts under the New York Convention and Saudi Arbitration Law.',
      },
      {
        title: 'Clause Drafting',
        description: 'Designing effective arbitration clauses that protect your interests and ensure enforceability, tailored to the specific needs of each transaction.',
      },
    ],
    processSteps: [
      { title: 'Case Assessment & Strategy', description: 'We evaluate the dispute, review arbitration clauses, assess jurisdictional considerations, and develop a comprehensive arbitration strategy.' },
      { title: 'Tribunal Constitution', description: 'We advise on arbitrator selection, manage the tribunal appointment process, and ensure the panel is constituted efficiently and fairly.' },
      { title: 'Submissions & Hearings', description: 'Our team prepares detailed written submissions, manages document production, presents evidence, and advocates powerfully during oral hearings.' },
      { title: 'Award & Enforcement', description: 'Following the award, we manage any challenges or applications for correction, then pursue enforcement through Saudi courts or internationally as needed.' },
    ],
    whyChooseUs: [
      {
        title: 'Institutional Experience',
        description: 'Extensive experience with all major arbitral institutions including ICC, LCIA, SIAC, and SCCA.',
      },
      {
        title: 'Saudi Law Expertise',
        description: 'Deep understanding of Saudi arbitration law and its interaction with Sharia principles and public policy.',
      },
      {
        title: 'Enforcement Focus',
        description: 'We think about enforceability from the start, ensuring awards can be effectively executed.',
      },
      {
        title: 'Cost Management',
        description: 'Strategic approach to arbitration that manages costs while maintaining the highest quality advocacy.',
      },
    ],
   faq: [
  {
    question: 'Is arbitration enforceable in Saudi Arabia?',
    answer: 'Yes, Saudi Arabia is a signatory to the New York Convention and has a modern Arbitration Law. Arbitral awards are generally enforceable through Saudi courts, subject to applicable legal requirements.',
  },
  {
    question: 'Which arbitration institution should I choose?',
    answer: 'The choice depends on your transaction type, counterparty, and preferred seat. The SCCA (Saudi Center for Commercial Arbitration) is commonly used for domestic disputes, while ICC and LCIA are often used for international matters.',
  },
],
    relatedServices: ['mediation', 'international-litigation', 'commercial-corporate-litigation'],
  },

   {
    slug: 'contract-drafting-&-support',
    title: 'Contract Drafting & Support',
     highlight: false,
    shortTitle: 'Contract Drafting',
    tagline: 'Precision in Every Clause, Protection in Every Agreement',
    heroDescription: 'Our contract practice delivers meticulously drafted agreements that protect your interests, minimize risk, and support your commercial objectives in the Saudi market.',
    heroImage: 'https://images.unsplash.com/photo-1589998059171-988d887df646?auto=format&fit=crop&w=1600&q=80',
    heroStats: [
      { value: '5,000+', label: 'Contracts Drafted' },
      { value: 'Zero', label: 'Disputes From Drafts' },
      { value: '48hrs', label: 'Avg Turnaround' },
    ],
    overview: 'Contracts are the foundation of every business relationship. In Saudi Arabia\'s dynamic commercial environment, well-drafted agreements that account for local legal requirements and cultural norms are essential. Our contract practice combines deep knowledge of Saudi contract law with practical commercial understanding to deliver agreements that are clear, enforceable, and protective of your interests.',
    overviewPoints: [
      'Commercial agreements and supply contracts',
      'Technology and licensing agreements',
      'Employment contracts and HR policies',
      'Real estate and construction contracts',
      'Distribution and franchise agreements',
      'Government and public sector contracts',
    ],
    offerings: [
      {
        title: 'Contract Drafting',
        description: 'Preparing bespoke contracts tailored to your specific transaction, ensuring compliance with Saudi law and protection of your commercial interests.',
      },
      {
        title: 'Contract Review & Negotiation',
        description: 'Reviewing counterparty-drafted agreements, identifying risks and issues, and negotiating favorable terms on your behalf.',
      },
      {
        title: 'Template Development',
        description: 'Creating standardized contract templates for recurring transactions, ensuring consistency and efficiency across your operations.',
      },
      {
        title: 'Contract Management Advisory',
        description: 'Advising on contract lifecycle management, including compliance monitoring, renewal strategies, and termination procedures.',
      },
    ],
    processSteps: [
      { title: 'Requirements Gathering', description: 'We discuss your transaction, understand the commercial relationship, identify key risks, and define the essential terms your contract must address.' },
      { title: 'Drafting & Review', description: 'Our team drafts the contract in Arabic and/or English, incorporating protective clauses, compliance requirements, and commercially balanced terms.' },
      { title: 'Negotiation Support', description: 'We represent you in contract negotiations, responding to counterparty markups, resolving contentious issues, and securing favorable terms.' },
      { title: 'Execution & Delivery', description: 'We finalize the contract, coordinate execution formalities, and deliver the signed agreement along with a summary of key obligations and deadlines.' },
    ],
    whyChooseUs: [
      {
        title: 'Bilingual Capability',
        description: 'Contracts drafted in both Arabic and English with equal precision, ensuring consistency across language versions.',
      },
      {
        title: 'Saudi Law Expertise',
        description: 'Deep understanding of Saudi contract law principles, including Sharia-based requirements and commercial code provisions.',
      },
      {
        title: 'Industry Knowledge',
        description: 'Sector-specific contract expertise across construction, technology, healthcare, energy, and financial services.',
      },
      {
        title: 'Practical Focus',
        description: 'Contracts that are commercially practical and operationally workable, not just legally defensible.',
      },
    ],
    faq: [
      {
        question: 'Do contracts need to be in Arabic to be enforceable in Saudi Arabia?',
        answer: 'While bilingual contracts are common, Arabic is the official language of Saudi courts. We recommend having an Arabic version of all important contracts, with the Arabic version prevailing in case of inconsistency.',
      },
      {
        question: 'Can you review contracts prepared by our in-house team?',
        answer: 'Yes, we regularly review and improve contracts drafted by in-house legal teams, identifying potential issues and suggesting enhancements aligned with Saudi law requirements.',
      },
      {
        question: 'How quickly can you draft a contract?',
        answer: 'Standard contracts can typically be delivered within 3-5 business days. Complex or bespoke agreements may take 1-2 weeks. We also offer expedited services for urgent matters.',
      },
    ],
    relatedServices: ['corporate-governance-services', 'commercial-corporate-litigation', 'intellectual-property'],
  },

   
  {
    slug: 'corporate-governance-services',
    title: 'Corporate Governance Services',
     highlight: false,
    shortTitle: 'Corporate Governance',
    tagline: 'Strengthening Oversight, Accountability & Transparency',
    heroDescription: 'We help organizations build robust governance frameworks that meet regulatory requirements, satisfy stakeholder expectations, and support sustainable growth.',
    heroImage: 'https://images.unsplash.com/photo-1709803857154-d20ee16ff763?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBnb3Zlcm5hbmNlJTIwYm9hcmQlMjBtZWV0aW5nfGVufDF8fHx8MTc3MTU2NjYwNXww&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: '200+', label: 'Boards Advised' },
      { value: '100%', label: 'CMA Compliance' },
      { value: '15+', label: 'Years of Practice' },
    ],
    overview: 'Good corporate governance is essential for building trust with investors, regulators, and stakeholders. Saudi Arabia\'s Capital Market Authority (CMA) and the Ministry of Commerce have established comprehensive governance requirements that companies must meet. Our governance practice helps organizations design, implement, and maintain governance frameworks that go beyond mere compliance to create genuine value.',
    overviewPoints: [
      'Board composition and effectiveness reviews',
      'Governance policy development and implementation',
      'Regulatory compliance assessments (CMA, MOC)',
      'Committee charter development (Audit, Nomination, Remuneration)',
      'Related party transaction frameworks',
      'ESG governance and sustainability reporting',
    ],
    offerings: [
      {
        title: 'Governance Framework Design',
        description: 'Developing comprehensive governance structures including board charters, committee terms of reference, and corporate policies aligned with Saudi regulations and international best practices.',
      },
      {
        title: 'Board Advisory',
        description: 'Advising boards and individual directors on their duties, liabilities, and best practices for effective corporate oversight and decision-making.',
      },
      {
        title: 'Compliance Assessments',
        description: 'Conducting thorough reviews of existing governance practices against regulatory requirements and identifying gaps and improvement opportunities.',
      },
      {
        title: 'Annual Governance Support',
        description: 'Ongoing support for annual general meetings, board meetings, regulatory filings, and governance reporting requirements.',
      },
    ],
    processSteps: [
      { title: 'Governance Audit', description: 'We conduct a thorough review of your current governance practices, comparing them against CMA/MOC requirements and international best practices.' },
      { title: 'Gap Analysis & Recommendations', description: 'We identify governance gaps and provide prioritized, actionable recommendations for improvement tailored to your organization\'s size and complexity.' },
      { title: 'Framework Development', description: 'Our team designs comprehensive governance frameworks — board charters, committee terms of reference, policies, and procedures aligned with your needs.' },
      { title: 'Implementation & Training', description: 'We support the rollout of new governance structures, provide board and management training, and ensure smooth adoption across the organization.' },
      { title: 'Ongoing Monitoring', description: 'We provide continuous governance support, including AGM preparation, regulatory filings, and periodic reviews to maintain compliance excellence.' },
    ],
    whyChooseUs: [
      {
        title: 'Regulatory Insight',
        description: 'Deep understanding of CMA and MOC governance requirements and expectations.',
      },
      {
        title: 'Practical Solutions',
        description: 'Governance frameworks that work in practice, not just on paper — tailored to your organization\'s size and needs.',
      },
      {
        title: 'International Standards',
        description: 'We incorporate international best practices alongside Saudi requirements for world-class governance.',
      },
      {
        title: 'Board Experience',
        description: 'Our advisors have direct board-level experience, bringing practical perspective to governance advice.',
      },
    ],
    faq: [
      {
        question: 'What governance requirements apply to Saudi companies?',
        answer: 'Requirements vary by company type. Listed companies must comply with CMA Corporate Governance Regulations, while other companies are subject to the Companies Law governance provisions. We advise on the specific requirements applicable to your organization.',
      },
      {
        question: 'Do small companies need corporate governance?',
        answer: 'Yes, while the regulatory requirements may be less stringent for smaller companies, good governance practices benefit organizations of all sizes by improving decision-making, reducing risk, and building stakeholder confidence.',
      },
      {
        question: 'Can you help prepare for a board evaluation?',
        answer: 'Yes, we conduct comprehensive board effectiveness evaluations, including individual director assessments, committee reviews, and recommendations for improvement.',
      },
    ],
    relatedServices: ['corporate-structuring', 'mergers-&-acquisitions', 'contract-drafting-&-support'],
  },

    {
    slug: 'trademark-registration',
    title: 'Trademark Registration',
     highlight: false,
    shortTitle: 'Trademark Registration',
    tagline: 'Protecting Your Brand Identity in the Kingdom',
    heroDescription: 'Our trademark practice provides comprehensive brand protection services, from strategic filing to enforcement, ensuring your marks are registered and safeguarded across Saudi Arabia and the GCC.',
    heroImage: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=1600&q=80',
    heroStats: [
      { value: '1,200+', label: 'Trademarks Registered' },
      { value: '98%', label: 'Approval Rate' },
      { value: '30+', label: 'Industry Sectors' },
    ],
    overview: 'In today\'s competitive marketplace, your brand is one of your most valuable assets. Trademark registration provides legal protection against unauthorized use, counterfeiting, and brand dilution. Our trademark practice offers end-to-end services for registering, managing, and enforcing trademarks in Saudi Arabia through the Saudi Authority for Intellectual Property (SAIP) and across the GCC region.',
    overviewPoints: [
      'Trademark search and clearance analysis',
      'Application filing with SAIP and GCC offices',
      'Madrid Protocol international registrations',
      'Trademark portfolio management and renewals',
      'Opposition and cancellation proceedings',
      'Brand protection and enforcement strategies',
    ],
    offerings: [
      {
        title: 'Trademark Search & Clearance',
        description: 'Comprehensive searches across Saudi and GCC trademark databases to assess availability and identify potential conflicts before filing.',
      },
      {
        title: 'Registration Services',
        description: 'Complete management of trademark applications including preparation, filing, prosecution, and registration with SAIP and GCC Patent Office.',
      },
      {
        title: 'Portfolio Management',
        description: 'Ongoing management of your trademark portfolio including renewal tracking, monitoring for infringements, and strategic expansion planning.',
      },
      {
        title: 'Enforcement & Defense',
        description: 'Vigorous enforcement against infringers through opposition proceedings, administrative complaints, customs recordation, and litigation.',
      },
    ],
    processSteps: [
      { title: 'Brand Strategy & Search', description: 'We discuss your brand strategy, conduct comprehensive trademark searches, and assess registrability risks across relevant jurisdictions and classes.' },
      { title: 'Application Preparation', description: 'Our team prepares and files trademark applications with SAIP, ensuring proper classification, descriptions, and supporting documentation.' },
      { title: 'Prosecution & Response', description: 'We manage the examination process, respond to office actions, overcome objections, and navigate opposition proceedings to secure registration.' },
      { title: 'Registration & Protection', description: 'Upon registration, we implement monitoring systems, set up renewal calendars, and provide ongoing enforcement support to protect your marks.' },
    ],
    whyChooseUs: [
      {
        title: 'SAIP Expertise',
        description: 'Deep experience with Saudi Authority for Intellectual Property procedures and requirements.',
      },
      {
        title: 'GCC Coverage',
        description: 'Seamless coordination of trademark protection across all GCC member states through our regional network.',
      },
      {
        title: 'Strategic Approach',
        description: 'We design trademark strategies aligned with your business expansion plans and budget constraints.',
      },
      {
        title: 'Enforcement Focus',
        description: 'Proactive monitoring and rapid enforcement actions to protect your brand from unauthorized use.',
      },
    ],
    faq: [
      {
        question: 'How long does trademark registration take in Saudi Arabia?',
        answer: 'A straightforward trademark application typically takes 12-18 months from filing to registration. Complex applications or those facing opposition may take longer. We provide regular status updates throughout the process.',
      },
      {
        question: 'Can I register an international trademark in Saudi Arabia?',
        answer: 'Yes, Saudi Arabia is a member of the Madrid Protocol, allowing international trademark applications to designate Saudi Arabia. We can file direct national applications or through the Madrid System.',
      },
      {
        question: 'What classes should I register my trademark under?',
        answer: 'The appropriate classes depend on your goods/services. We recommend registering in all classes relevant to your current and planned business activities to ensure comprehensive protection.',
      },
    ],
    relatedServices: ['intellectual-property', 'contract-drafting-&-support', 'regulatory-compliance'],
  },
  {
    slug: 'regulatory-compliance',
    title: 'Regulatory Compliance',
     highlight: false,
    shortTitle: 'Regulatory Compliance',
    tagline: 'Navigating Complex Regulations with Confidence',
    heroDescription: 'Our regulatory compliance practice helps organizations understand, implement, and maintain compliance with Saudi Arabia\'s evolving regulatory landscape across all major sectors.',
    heroImage: 'https://images.unsplash.com/photo-1704969724221-8b7361b61f75?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZWd1bGF0b3J5JTIwY29tcGxpYW5jZSUyMGJ1c2luZXNzJTIwbGVnYWx8ZW58MXx8fHwxNzc1Mzg5OTg5fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    heroStats: [
      { value: '500+', label: 'Compliance Programs' },
      { value: '100%', label: 'Audit Success Rate' },
      { value: '20+', label: 'Regulatory Bodies' },
    ],
    overview: 'Saudi Arabia\'s regulatory environment is undergoing rapid transformation under Vision 2030, with new laws, regulations, and enforcement priorities emerging across all sectors. Staying compliant requires constant vigilance and deep expertise. Our regulatory compliance practice provides comprehensive support for understanding applicable requirements, designing compliance programs, and maintaining ongoing regulatory good standing.',
    overviewPoints: [
      'Sector-specific regulatory compliance (CMA, SAMA, CITC, SFDA, etc.)',
      'Anti-Money Laundering (AML) and Counter-Terrorist Financing (CTF)',
      'Data protection and privacy compliance (PDPL)',
      'Competition law and antitrust compliance',
      'Labor law and Saudization requirements',
      'ESG and sustainability compliance frameworks',
    ],
    offerings: [
      {
        title: 'Compliance Assessment',
        description: 'Comprehensive audits of your current compliance posture, identifying gaps against applicable regulatory requirements and industry best practices.',
      },
      {
        title: 'Program Development',
        description: 'Designing and implementing tailored compliance programs including policies, procedures, training, and monitoring systems.',
      },
      {
        title: 'Regulatory Advisory',
        description: 'Ongoing advisory on regulatory changes, interpretation of new requirements, and strategic compliance planning.',
      },
      {
        title: 'Regulatory Filings',
        description: 'Managing required regulatory filings, notifications, and reporting obligations with CMA, MISA, sector regulators, and government entities.',
      },
    ],
    processSteps: [
      { title: 'Compliance Gap Analysis', description: 'We conduct a thorough review of your operations, comparing current practices against applicable regulatory requirements to identify compliance gaps.' },
      { title: 'Program Design', description: 'Our team designs a comprehensive compliance program tailored to your organization — including policies, procedures, controls, and monitoring systems.' },
      { title: 'Implementation & Training', description: 'We support rollout of compliance frameworks, provide employee training, and ensure proper understanding across all levels of your organization.' },
      { title: 'Ongoing Monitoring', description: 'We establish continuous monitoring systems, conduct periodic compliance reviews, and provide regulatory intelligence to keep you ahead of changes.' },
    ],
    whyChooseUs: [
      {
        title: 'Multi-Sector Experience',
        description: 'Deep compliance expertise across financial services, healthcare, technology, energy, and other heavily regulated sectors.',
      },
      {
        title: 'Regulatory Intelligence',
        description: 'Direct access to regulatory developments and advance notice of upcoming changes through our government relationships.',
      },
      {
        title: 'Practical Solutions',
        description: 'Compliance programs designed to work within your business operations, not disrupt them.',
      },
      {
        title: 'Enforcement Defense',
        description: 'Experienced in representing clients in regulatory investigations and enforcement proceedings.',
      },
    ],
    faq: [
      {
        question: 'How do I know which regulations apply to my business?',
        answer: 'Applicable regulations depend on your sector, activities, size, and customer base. We conduct compliance assessments to identify all relevant regulatory requirements for your specific operations.',
      },
      {
        question: 'What are the penalties for regulatory non-compliance?',
        answer: 'Penalties vary by regulation and severity, ranging from warnings and fines to license suspension or criminal prosecution. We help you understand specific risks and implement compliance to avoid these consequences.',
      },
      {
        question: 'Can you represent us in regulatory investigations?',
        answer: 'Yes, our team regularly represents clients in regulatory investigations, enforcement proceedings, and administrative appeals before Saudi regulatory authorities.',
      },
    ],
    relatedServices: ['corporate-governance-services', 'contract-drafting-&-support', 'trademark-registration'],
  },

  {
    slug: 'investment-solutions',
    title: 'Investment Solutions',
     highlight: false,
    shortTitle: 'Investment Solutions',
    tagline: 'Structuring Success for Investors in the Kingdom',
    heroDescription: 'We provide comprehensive legal advisory for investors entering the Saudi market, from initial structuring through to ongoing regulatory compliance and portfolio management.',
    heroImage: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080',
    heroStats: [
      { value: 'SAR 10B+', label: 'Investments Advised' },
      { value: '200+', label: 'Transactions' },
      { value: '100%', label: 'Compliance Record' },
    ],
    overview: 'Saudi Arabia\'s Vision 2030 has created unprecedented investment opportunities across diverse sectors. Navigating the regulatory framework, understanding incentive programs, and structuring investments for maximum return requires specialized legal expertise. Our investment solutions practice guides institutional and private investors through every aspect of their Saudi investment journey.',
    overviewPoints: [
      'Foreign Direct Investment (FDI) structuring and MISA licensing',
      'Sector-specific investment regulations and incentives',
      // 'Public-Private Partnership (PPP) advisory',
      // 'Fund structuring and capital raising',
      'Real estate investment advisory',
      'Investment dispute prevention and resolution',
    ],
    offerings: [
      {
        title: 'Market Entry Advisory',
        description: 'Comprehensive guidance on the legal and regulatory requirements for entering the Saudi market, including entity selection, licensing, and incentive programs.',
      },
      {
        title: 'Investment Structuring',
        description: 'Designing optimal investment structures that balance, and regulatory compliance, including joint ventures, direct ownership',
      },
      {
        title: 'Regulatory Compliance',
        description: 'Ongoing advisory on investment-related regulatory requirements, including MISA compliance and reporting obligations.',
      },
      {
        title: 'Investment Protection',
        description: 'Dispute prevention strategies.',
      },
    ],
  processSteps: [
  {
    title: 'Initial Consultation',
    description: 'We understand your business objectives and provide an overview of the legal and regulatory framework applicable to your investment in Saudi Arabia.'
  },
  {
    title: 'Legal Structuring',
    description: 'We advise on the appropriate legal structures, including entity formation options and governance frameworks, ensuring full compliance with Saudi regulations.'
  },
  {
    title: 'Licensing & Approvals',
    description: 'We handle all legal procedures related to licensing, including MISA applications, sector-specific approvals, and coordination with relevant authorities.'
  },
  {
    title: 'Documentation & Setup',
    description: 'We prepare and review all required legal documentation, complete company registration, and support the formal establishment of your presence in the Kingdom.'
  },
  {
    title: 'Ongoing Legal Support',
    description: 'We provide continuous legal assistance to ensure regulatory compliance, corporate governance, and support for future business activities in Saudi Arabia.'
  }
],
    whyChooseUs: [
      {
        title: 'Vision 2030 Expertise',
        description: 'Deep understanding of Saudi Arabia\'s investment landscape and the opportunities created by Vision 2030.',
      },
      {
        title: 'Multi-Sector Coverage',
        description: 'Experience across all major investment sectors from energy and infrastructure to technology and healthcare.',
      },
      // {
      //   title: 'Government Relations',
      //   description: 'Strong relationships with investment authorities and regulatory bodies facilitate smooth processes.',
      // },
      {
        title: 'Ongoing Partnership',
        description: 'We support investors beyond initial entry, providing continuous legal support for growing operations.',
      },
    ],
    faq: [
      {
        question: 'What incentives are available for foreign investors in Saudi Arabia?',
        answer: 'Saudi Arabia offers numerous incentives including tax exemptions, reduced licensing fees, access to Special Economic Zones, and sector-specific benefits under Vision 2030 programs. We help identify and maximize applicable incentives for your investment.',
      },
      {
        question: 'Can I invest in any sector as a foreign investor?',
        answer: 'While most sectors are now open to foreign investment, some activities remain restricted or require specific approvals. We provide sector-specific guidance to ensure your investment complies with all applicable regulations.',
      },
      {
        question: 'What is the minimum capital requirement for foreign investment?',
        answer: 'Capital requirements vary by entity type and sector. The minimums have been significantly reduced under recent reforms. We advise on the specific requirements applicable to your planned investment.',
      },
    ],
    relatedServices: ['corporate-structuring', 'foreign-company-incorporation', 'mergers-&-acquisitions'],
  },

   {
    slug: 'foreign-company-incorporation',
     highlight: false,
    title: 'Foreign Company Incorporation',
    shortTitle: 'Foreign Incorporation',
    tagline: 'Your Gateway to the Saudi Market',
    heroDescription: 'We guide international businesses through every step of establishing their presence in Saudi Arabia, ensuring a smooth and compliant market entry.',
    heroImage: 'https://images.unsplash.com/photo-1767122227285-a75dced30c8a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmb3JlaWduJTIwY29tcGFueSUyMGdsb2JhbCUyMGJ1c2luZXNzfGVufDF8fHx8MTc3MTU2NjYwM3ww&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: '2000+', label: 'Companies Formed' },
      { value: '30+', label: 'Origin Countries' },
      { value: '100%', label: 'Approval Rate' },
    ],
    overview: 'Saudi Arabia has undergone transformative reforms to attract foreign investment, but the incorporation process still requires careful navigation of regulatory requirements, licensing procedures, and compliance obligations. Our foreign incorporation practice provides comprehensive support from initial feasibility through to fully operational status, drawing on deep experience with MISA, MOC, and sector-specific regulators.',
    overviewPoints: [
      'MISA (Ministry of Investment) licensing and approvals',
      'Commercial Registration and Chamber of Commerce enrollment',
      'Entity type selection and structuring advice',
      'Bank account opening and capital injection procedures',
      'Visa and work permit processing for key personnel',
      'Sector-specific regulatory approvals and licenses',
    ],
    offerings: [
      {
        title: 'Feasibility & Planning',
        description: 'Comprehensive assessment of your market entry options, including entity type comparison, cost analysis, and timeline projections for Saudi establishment.',
      },
      {
        title: 'MISA Licensing',
        description: 'Full management of the MISA foreign investment license application process, including documentation preparation, submission, and follow-up.',
      },
      {
        title: 'Formation & Registration',
        description: 'Handling all formation steps including Articles of Association, Commercial Registration, tax registration, and enrollment with relevant authorities.',
      },
      {
        title: 'Operational Setup',
        description: 'Supporting the practical aspects of becoming operational, including bank account opening, visa processing, office leasing, and initial compliance setup.',
      },
    ],
    processSteps: [
{ 
  title: 'Initial Consultation', 
  description: 'We understand your business objectives, outline the legal framework for market entry, and guide you on suitable structuring options within the Saudi regulatory environment.' 
},
      { title: 'MISA License Application', description: 'Our team prepares and submits your foreign investment license application to MISA, managing all documentation and follow-up communications.' },
      { title: 'Company Formation', description: 'Upon license approval, we handle Articles of Association, Commercial Registration, tax enrollment, and all required authority registrations.' },
      { title: 'Operational Readiness', description: 'We support bank account opening, visa processing for key personnel, office setup, and initial compliance frameworks to get you operational quickly.' },
      { title: 'Compliance Handover', description: 'We provide a comprehensive handover of all corporate documents and set up ongoing compliance calendars so you remain in good standing.' },
    ],
    whyChooseUs: [
      {
        title: 'Proven Process',
        description: 'Hundreds of successful foreign company incorporations across all major sectors and entity types.',
      },
    {
  title: 'Regulatory Experience',
  description: 'Extensive experience in handling applications and coordinating with MISA, MOC, and relevant sector regulators to ensure efficient processing.'
},
      {
        title: 'Full-Service Support',
        description: 'We handle everything from licensing to bank accounts to visas — a single point of contact for your entire setup.',
      },
      {
        title: 'Post-Formation Care',
        description: 'Ongoing compliance support ensures your entity remains in good standing with all regulatory requirements.',
      },
    ],
    faq: [
      {
        question: 'What types of entities can a foreign company establish in Saudi Arabia?',
        answer: 'Options include a wholly-owned LLC, Joint Stock Company, branch office, representative office, or a joint venture with a Saudi partner. The best choice depends on your business objectives, sector, and operational plans.',
      },
      {
        question: 'Is 100% foreign ownership allowed in Saudi Arabia?',
        answer: 'Yes, 100% foreign ownership is now permitted in most sectors following recent liberalization reforms. Some activities may still require a Saudi partner, but the trend is toward greater openness.',
      },
      {
        question: 'What is the timeline for incorporating a foreign company?',
        answer: 'A typical incorporation takes 6-12 weeks depending on entity type, sector-specific requirements, and document readiness. We work to minimize delays through proactive preparation and regulatory engagement.',
      },
    ],
    relatedServices: ['local-company-incorporation', 'corporate-structuring', 'investment-solutions'],
  },

 {
    slug: 'local-company-incorporation',
    title: 'Local Company Incorporation',
     highlight: false,
    shortTitle: 'Local Incorporation',
    tagline: 'Establishing Saudi Enterprises with Confidence',
    heroDescription: 'We provide efficient, comprehensive support for establishing local companies in Saudi Arabia, from initial structuring through to full operational readiness.',
    heroImage: 'https://images.unsplash.com/photo-1647973035166-2abf410c68b0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsb2NhbCUyMGJ1c2luZXNzJTIwaW5jb3Jwb3JhdGlvbiUyMHN0YXJ0dXB8ZW58MXx8fHwxNzcxNTY2NjA0fDA&ixlib=rb-4.1.0&q=80&w=1080',
   heroStats: [
  { value: '800+', label: 'Companies Registered' },
  { value: '5–7 Days', label: 'Typical Setup Time' },
  { value: '100%', label: 'Success Rate' },
],
    overview: 'Establishing a local company in Saudi Arabia is the foundation of doing business in the Kingdom. Whether you\'re a Saudi entrepreneur launching a new venture, a family business formalizing its structure, or an existing company expanding operations, our local incorporation team ensures your entity is properly established, compliant, and ready for business.',
    overviewPoints: [
      'Limited Liability Company (LLC) formation',
      'Joint Stock Company (JSC) establishment',
      'Sole Proprietorship registration',
      'Professional Company formation',
      'Non-Profit Organization establishment',
      'Special Purpose Vehicle (SPV) creation',
    ],
   offerings: [
  {
    title: 'Entity Selection Advisory',
    description: 'Expert guidance on choosing the right entity type based on your business activities, ownership structure, and long-term objectives within the Saudi regulatory framework.',
  },
  {
    title: 'Formation Documentation',
    description: 'Preparation of all required corporate documents including Articles of Association, Memorandum of Association, and related governance documentation.',
  },
  {
    title: 'Registration & Licensing',
    description: 'Complete management of Commercial Registration, tax registration, GOSI registration, and coordination for sector-specific licenses and approvals.',
  },
  {
    title: 'Startup Support Package',
    description: 'Comprehensive legal support for startups including structuring, incorporation, and preparation of key shareholder and governance agreements.',
  },
],
    processSteps: [
      { title: 'Consultation & Planning', description: 'We discuss your business activities, ownership plans, and growth objectives to recommend the ideal entity type and structure for your needs.' },
      { title: 'Document Preparation', description: 'Our team drafts Articles of Association, Memorandum of Association, and all required governance documents tailored to your specific requirements.' },
      { title: 'Registration & Licensing', description: 'We handle Commercial Registration, municipal licensing, tax registration, GOSI enrollment, and any sector-specific permits required for your activities.' },
      { title: 'Operational Launch', description: 'We support your company\'s operational launch with bank account setup, initial compliance configurations, and practical guidance for starting operations.' },
    ],
    whyChooseUs: [
      {
        title: 'Speed & Efficiency',
        description: 'Streamlined processes to get your company registered and operational as quickly as possible.',
      },
      {
        title: 'Comprehensive Service',
        description: 'All registration steps handled under one roof — no need to coordinate multiple service providers.',
      },
      {
        title: 'Transparent Pricing',
        description: 'Clear, upfront pricing with no hidden fees or surprise costs throughout the formation process.',
      },
      {
        title: 'Growth-Ready Structures',
        description: 'We design your corporate structure with future growth and investment in mind from day one.',
      },
    ],
    faq: [
      {
        question: 'What is the minimum capital required to form an LLC in Saudi Arabia?',
        answer: 'Saudi Arabia has removed the minimum capital requirement for LLCs in most sectors, making it more accessible for entrepreneurs. However, some activities may have specific capital requirements.',
      },
      {
        question: 'How long does local company registration take?',
        answer: 'A standard LLC registration can be completed within 1-3 weeks for straightforward cases. More complex structures or those requiring special approvals may take longer.',
      },
      {
        question: 'Can I convert my entity type later?',
        answer: 'Yes, Saudi law allows conversion between entity types (e.g., from LLC to JSC) subject to meeting certain requirements. We advise on the process and manage the conversion.',
      },
    ],
    relatedServices: ['foreign-company-incorporation', 'corporate-structuring', 'corporate-governance-services'],
  },

   {
    slug: 'mergers-&-acquisitions',
     highlight: false,
    title: 'Mergers & Acquisitions',
    shortTitle: 'M&A',
    tagline: 'Driving Strategic Growth Through Transactions',
    heroDescription: 'Our M&A team advises on the full spectrum of transactions — from small bolt-on acquisitions to transformative cross-border mergers — delivering strategic counsel at every stage.',
    heroImage: 'https://images.unsplash.com/photo-1591453214154-c95db71dbd83?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtZXJnZXJzJTIwYWNxdWlzaXRpb25zJTIwY29ycG9yYXRlJTIwaGFuZHNoYWtlfGVufDF8fHx8MTc3MTU2NjYwM3ww&ixlib=rb-4.1.0&q=80&w=1080',
    heroStats: [
      { value: '150+', label: 'Transactions Closed' },
      // { value: 'SAR 8B+', label: 'Deal Value' },
      { value: '98%', label: 'Completion Rate' },
    ],
    overview: 'The Saudi M&A market is experiencing significant growth driven by Vision 2030 privatization initiatives, cross-border interest, and domestic consolidation. Our team provides end-to-end transaction advisory, combining legal rigor with commercial pragmatism to help clients achieve their strategic objectives. We have advised on some of the largest and most complex transactions in the Kingdom.',
    overviewPoints: [
      'Share and asset acquisitions',
      'Mergers and corporate combinations',
      'Private equity and venture capital transactions',
      'Management buyouts and leveraged acquisitions',
      'Joint ventures and strategic alliances',
      'Divestitures and carve-outs',
    ],
  offerings: [
  {
    title: 'Transaction Advisory',
    description: 'Legal support across private equity and venture capital transactions, including structuring, negotiation, and execution of investments.',
  },
  {
    title: 'Legal Due Diligence',
    description: 'Legal due diligence covering corporate, regulatory, commercial, and employment matters relevant to the transaction.',
  },
  {
    title: 'Transaction Documentation',
    description: 'Drafting and negotiating all transaction documents including SPAs, shareholders\' agreements, and ancillary transaction documents.',
  },
  {
    title: 'Regulatory Approvals',
    description: 'Managing regulatory approval processes including competition authority filings, sector-specific approvals, and coordination with MISA and MOC.',
  },
],
  processSteps: [
  {
    title: 'Transaction Strategy',
    description: 'We help define your acquisition criteria, identify targets (if required), and develop a transaction strategy aligned with your strategic objectives.',
  },
  {
    title: 'Due Diligence',
    description: 'Our team conducts comprehensive legal due diligence — reviewing corporate, regulatory, employment, and litigation matters to identify key risks.',
  },
  {
    title: 'Negotiation & Documentation',
    description: 'We assist in negotiation of deal terms and draft SPAs, shareholders\' agreements, and all ancillary documents, ensuring your interests are fully protected.',
  },
  {
    title: 'Regulatory & Closing',
    description: 'We manage competition filings, sector approvals, and coordination with MISA and MOC, and support all closing mechanics for a seamless transaction completion.',
  },
  {
    title: 'Post-Completion Integration',
    description: 'After closing, we support legal integration activities, including corporate restructuring, contract novations, and ongoing compliance requirements.',
  },
],
    whyChooseUs: [
      {
        title: 'Transaction Experience',
        description: 'Extensive deal experience across diverse sectors and transaction sizes in the Saudi market.',
      },
      {
        title: 'Commercial Approach',
        description: 'We focus on getting deals done while protecting your interests.',
      },
      {
        title: 'Cross-Border Capability',
        description: 'Experienced in coordinating multi-jurisdictional transactions with international counsel teams.',
      },
    {
  title: 'Speed & Efficiency',
  description: 'Proven ability to execute transactions within demanding timelines without compromising quality.',
},
    ],
    faq: [
      {
        question: 'what legal due diligence is required for M&A in Saudi Arabia?',
        answer: 'Standard due diligence covers corporate structure, regulatory compliance, contracts, employment, real estate, IP, litigation, and tax. The scope is tailored based on the target company\'s industry, size, and risk profile.',
      },
      // {
      //   question: 'Are there competition law requirements for M&A transactions?',
      //   answer: 'Yes, mergers and acquisitions meeting certain thresholds require approval from the General Authority for Competition. We manage the entire notification and approval process.',
      // },
      {
        question: 'How long does a typical M&A transaction take in Saudi Arabia?',
        answer: 'Timelines vary significantly based on complexity, but a typical mid-market transaction takes 3-6 months from signing to closing. Complex deals or those requiring multiple regulatory approvals may take longer.',
      },
    ],
    relatedServices: ['corporate-structuring', 'investment-solutions', 'contract-drafting-&-support'],
  },

  
   {
    slug: 'corporate-restructuring',
    title: 'Corporate Restructuring',
     highlight: false,
    shortTitle: 'Corporate Restructuring',
    tagline: 'Strategic Reorganization for Business Transformation',
    heroDescription: 'Our corporate restructuring practice guides organizations through complex reorganizations, helping optimize structure, unlock value, and position for future growth in the Saudi market.',
    heroImage: 'https://images.unsplash.com/photo-1731458769726-cef60c792665?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjByZXN0cnVjdHVyaW5nJTIwYnVzaW5lc3MlMjB0cmFuc2Zvcm1hdGlvbnxlbnwxfHx8fDE3NzUzODk5OTB8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    heroStats: [
      { value: '250+', label: 'Restructurings Completed' },
      { value: 'SAR 12B+', label: 'Assets Restructured' },
      { value: '100%', label: 'Regulatory Approval' },
    ],
    overview: 'Corporate restructuring is essential when businesses need to adapt to changing market conditions, optimize operations, prepare for growth, or respond to financial challenges. Whether driven by strategic opportunity or operational necessity, restructuring requires careful legal planning, regulatory navigation, and stakeholder management. Our restructuring practice provides end-to-end support for all forms of corporate reorganization in Saudi Arabia.',
    overviewPoints: [
      'Group reorganizations and holding company structures',
      'Asset transfers and business carve-outs',
      'Pre-IPO restructuring and corporate simplification',
      'Debt restructuring and creditor arrangements',
      'Cross-border restructuring and domicile changes',
      'Distressed company restructuring and turnarounds',
    ],
    offerings: [
      {
        title: 'Strategic Restructuring',
        description: 'Designing and implementing corporate reorganizations to optimize structure, improve efficiency, and unlock shareholder value.',
      },
      {
        title: 'Pre-Transaction Restructuring',
        description: 'Restructuring corporate groups ahead of M&A, IPOs, or major investments to facilitate transactions and maximize value.',
      },
      {
        title: 'Regulatory Approvals',
        description: 'Managing all regulatory requirements for restructurings including MISA approvals, MOC filings, tax clearances, and sector-specific consents.',
      },
      {
        title: 'Financial Restructuring',
        description: 'Advising on debt restructuring, creditor negotiations, and formal insolvency alternatives under the Saudi Bankruptcy Law.',
      },
    ],
    processSteps: [
      { title: 'Business Review & Strategy', description: 'We analyze your current structure, understand strategic objectives, identify opportunities, and design optimal restructuring approach.' },
      { title: 'Structuring & Planning', description: 'Our team develops detailed restructuring plan — entity changes, asset transfers, contract novations, and transition mechanics with full regulatory compliance.' },
      { title: 'Regulatory Approval', description: 'We manage all regulatory interactions including MISA approvals, MOC registrations, tax rulings, and sector-specific consents for the restructuring.' },
      { title: 'Implementation & Completion', description: 'We execute the restructuring — transferring assets, novating contracts, updating governance, and completing all formalities to finalize the new structure.' },
    ],
    whyChooseUs: [
      {
        title: 'Complex Structure Experience',
        description: 'Extensive experience with multi-entity, cross-border, and highly complex corporate restructurings.',
      },
      {
        title: 'Tax Coordination',
        description: 'Close coordination with tax advisors to structure transactions in tax-efficient manner under Saudi tax law.',
      },
      {
        title: 'Regulatory Navigation',
        description: 'Proven ability to secure regulatory approvals for complex restructurings from MISA, MOC, and sector regulators.',
      },
      {
        title: 'Speed & Execution',
        description: 'Efficient project management to complete restructurings on tight timelines without compromising legal rigor.',
      },
    ],
    faq: [
      {
        question: 'When should a company consider restructuring?',
        answer: 'Restructuring is appropriate when preparing for growth, optimizing operations, addressing financial challenges, preparing for investment/IPO, or responding to regulatory changes. We assess whether restructuring is right for your situation.',
      },
      {
        question: 'How long does a corporate restructuring take?',
        answer: 'Timelines vary based on complexity and regulatory approvals required. Simple reorganizations may take 2-3 months, while complex multi-entity restructurings can take 6-12 months.',
      },
      {
        question: 'What approvals are needed for restructuring in Saudi Arabia?',
        answer: 'Requirements vary but typically include MISA approval (for foreign-owned entities), MOC Commercial Registration amendments, tax clearances, and sector-specific regulatory consents.',
      },
    ],
    relatedServices: ['mergers-&-acquisitions', 'corporate-structuring', 'investment-solutions'],
  },

  // {
  //   slug: 'corporate-structuring',
  //   title: 'Corporate Structuring',
  //   shortTitle: 'Corporate Structuring',
  //   tagline: 'Building the Foundation for Your Business Success',
  //   heroDescription: 'We design and implement optimal corporate structures that align with your strategic objectives, regulatory requirements, and growth aspirations in the Saudi market.',
  //   heroImage: 'https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBsYXclMjBvZmZpY2UlMjBtZWV0aW5nfGVufDF8fHx8MTc3MTU2NjYwMXww&ixlib=rb-4.1.0&q=80&w=1080',
  //   heroStats: [
  //     { value: '1,200+', label: 'Entities Formed' },
  //     { value: '15+', label: 'Years of Expertise' },
  //     { value: '98%', label: 'Client Retention' },
  //   ],
  //   overview: 'Corporate structuring is the backbone of any successful enterprise operating in Saudi Arabia. Our team helps businesses establish the right legal entities, optimize ownership frameworks, and ensure compliance with the Kingdom\'s evolving regulatory landscape. Whether you\'re a multinational entering the Saudi market or a local enterprise planning expansion, we provide strategic counsel that aligns your corporate architecture with your commercial goals.',
  //   overviewPoints: [
  //     'Entity selection and formation (LLC, JSC, Branch Office, Representative Office)',
  //     'Joint venture structuring and partnership agreements',
  //     'Holding company and subsidiary architectures',
  //     'Cross-border corporate restructuring',
  //     'Shareholder agreements and governance frameworks',
  //     'Capital structuring and equity arrangements',
  //   ],
  //   offerings: [
  //     {
  //       title: 'Entity Formation & Registration',
  //       description: 'End-to-end support for establishing the appropriate legal entity in Saudi Arabia, including MISA licensing, Commercial Registration, and all regulatory approvals.',
  //     },
  //     {
  //       title: 'Corporate Reorganization',
  //       description: 'Strategic restructuring of existing entities to improve operational efficiency, tax optimization, and compliance with new regulatory requirements.',
  //     },
  //     {
  //       title: 'Joint Venture Structures',
  //       description: 'Designing and negotiating joint venture arrangements that protect your interests while enabling effective collaboration with Saudi and international partners.',
  //     },
  //     {
  //       title: 'Governance Frameworks',
  //       description: 'Developing comprehensive governance structures including board compositions, committee charters, and decision-making protocols aligned with Saudi corporate law.',
  //     },
  //   ],
  //   processSteps: [
  //     { title: 'Strategic Assessment', description: 'We begin with an in-depth analysis of your business objectives, ownership requirements, and regulatory landscape to identify the optimal corporate structure.' },
  //     { title: 'Structure Design', description: 'Our team designs a tailored corporate architecture — selecting entity types, ownership frameworks, and governance models aligned with your goals.' },
  //     { title: 'Documentation & Filing', description: 'We prepare all necessary corporate documents, articles of association, and regulatory filings, then submit them to the relevant authorities.' },
  //     { title: 'Regulatory Approvals', description: 'We liaise with MISA, MOC, and sector regulators to secure all required licenses and approvals on your behalf.' },
  //     { title: 'Implementation & Handover', description: 'Once approved, we finalize the structure, set up governance frameworks, and provide a comprehensive handover with ongoing compliance guidance.' },
  //   ],
  //   whyChooseUs: [
  //     {
  //       title: 'Deep Local Expertise',
  //       description: 'Over a decade of experience navigating Saudi Arabia\'s unique corporate regulatory environment.',
  //     },
  //     {
  //       title: 'Strategic Approach',
  //       description: 'We don\'t just form entities — we design structures that support your long-term business objectives.',
  //     },
  //     {
  //       title: 'Regulatory Relationships',
  //       description: 'Established working relationships with MISA, MOC, and other key regulatory bodies.',
  //     },
  //     {
  //       title: 'End-to-End Support',
  //       description: 'From initial strategy through formation to ongoing compliance, we support you at every stage.',
  //     },
  //   ],
  //   faq: [
  //     {
  //       question: 'What is the best corporate structure for foreign investors in Saudi Arabia?',
  //       answer: 'The optimal structure depends on your business objectives, investment size, and industry. Common options include a Limited Liability Company (LLC), Joint Stock Company (JSC), or a branch office. We provide tailored advice based on your specific circumstances.',
  //     },
  //     {
  //       question: 'How long does it take to incorporate a company in Saudi Arabia?',
  //       answer: 'The timeline varies by entity type and complexity. A standard LLC can be established within 4-8 weeks, while more complex structures may take 8-12 weeks. We expedite the process through our established regulatory relationships.',
  //     },
  //     {
  //       question: 'Do I need a Saudi partner to establish a company?',
  //       answer: 'Recent reforms allow 100% foreign ownership in many sectors. However, certain industries still require Saudi participation. We help determine the best approach based on your target sector and activity.',
  //     },
  //   ],
  //   relatedServices: ['mergers-acquisitions', 'foreign-company-incorporation', 'corporate-governance-services'],
  // },
  // {
  //   slug: 'international-litigation',
  //   title: 'International Litigation',
  //   shortTitle: 'International Litigation',
  //   tagline: 'Protecting Your Interests Across Borders',
  //   heroDescription: 'Our international litigation team represents clients in complex cross-border disputes, leveraging deep expertise in Saudi and international law to protect your interests globally.',
  //   heroImage: 'https://images.unsplash.com/photo-1758541213979-fe8c9996e197?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb3VydHJvb20lMjBqdXN0aWNlJTIwbGVnYWwlMjBwcm9jZWVkaW5nc3xlbnwxfHx8fDE3NzE1NjY2MDl8MA&ixlib=rb-4.1.0&q=80&w=1080',
  //   heroStats: [
  //     { value: '500+', label: 'Cases Handled' },
  //     { value: '40+', label: 'Jurisdictions' },
  //     { value: '95%', label: 'Success Rate' },
  //   ],
  //   overview: 'International disputes require a nuanced understanding of multiple legal systems, cultural sensitivities, and enforcement mechanisms. Our litigation team combines deep knowledge of Saudi judicial procedures with international legal expertise to deliver effective advocacy in cross-border disputes. We have successfully represented multinational corporations, sovereign entities, and high-net-worth individuals in complex international proceedings.',
  //   overviewPoints: [
  //     'Cross-border commercial disputes before Saudi courts',
  //     'Enforcement of foreign judgments and arbitral awards in the Kingdom',
  //     'International trade disputes and treaty claims',
  //     'Multi-jurisdictional litigation coordination',
  //     'Diplomatic and sovereign immunity matters',
  //     'International regulatory investigations',
  //   ],
  //   offerings: [
  //     {
  //       title: 'Cross-Border Dispute Resolution',
  //       description: 'Representing clients in international commercial disputes involving multiple jurisdictions, including claims before Saudi courts and coordination with foreign counsel.',
  //     },
  //     {
  //       title: 'Judgment & Award Enforcement',
  //       description: 'Securing enforcement of foreign court judgments and international arbitral awards in Saudi Arabia under local enforcement procedures and international treaties.',
  //     },
  //     {
  //       title: 'International Trade Litigation',
  //       description: 'Handling disputes arising from international trade, including breach of contract, trade finance disputes, and cross-border regulatory conflicts.',
  //     },
  //     {
  //       title: 'Strategic Case Assessment',
  //       description: 'Comprehensive evaluation of the merits, risks, and costs of international litigation to help clients make informed decisions about dispute strategy.',
  //     },
  //   ],
  //   processSteps: [
  //     { title: 'Case Evaluation', description: 'We conduct a thorough assessment of your dispute — analyzing facts, jurisdictional issues, applicable laws, and the strength of your position across borders.' },
  //     { title: 'Strategy Development', description: 'Our team designs a multi-jurisdictional litigation strategy, identifying optimal forums, coordinating with foreign counsel, and mapping out the path to resolution.' },
  //     { title: 'Proceedings & Advocacy', description: 'We file claims, manage discovery, prepare submissions, and represent you vigorously before Saudi courts or coordinate actions in foreign jurisdictions.' },
  //     { title: 'Judgment & Enforcement', description: 'Upon securing a favorable outcome, we manage the enforcement process — whether executing Saudi judgments locally or enforcing foreign judgments in the Kingdom.' },
  //   ],
  //   whyChooseUs: [
  //     {
  //       title: 'Global Network',
  //       description: 'We maintain relationships with leading firms across major jurisdictions to coordinate multi-forum strategies.',
  //     },
  //     {
  //       title: 'Bilingual Advocacy',
  //       description: 'Our team operates fluently in both Arabic and English, ensuring no nuance is lost in cross-border proceedings.',
  //     },
  //     {
  //       title: 'Track Record',
  //       description: 'Proven success in high-value international disputes involving Fortune 500 companies and sovereign entities.',
  //     },
  //     {
  //       title: 'Cultural Bridge',
  //       description: 'We bridge the gap between international business practices and Saudi legal culture for optimal outcomes.',
  //     },
  //   ],
  //   faq: [
  //     {
  //       question: 'Can foreign court judgments be enforced in Saudi Arabia?',
  //       answer: 'Yes, foreign judgments can be enforced in Saudi Arabia subject to certain conditions, including reciprocity requirements and compliance with Saudi public policy. Our team has extensive experience navigating the enforcement process.',
  //     },
  //     {
  //       question: 'What types of international disputes do you handle?',
  //       answer: 'We handle a wide range of cross-border disputes including commercial contract disputes, investment treaty claims, international trade disagreements, and multi-jurisdictional corporate disputes.',
  //     },
  //     {
  //       question: 'How do you coordinate with foreign law firms?',
  //       answer: 'We maintain a global network of trusted partner firms and regularly coordinate multi-jurisdictional litigation strategies to ensure consistent representation across all relevant forums.',
  //     },
  //   ],
  //   relatedServices: ['commercial-corporate-litigation', 'arbitration', 'debt-recovery'],
  // },
  // {
  //   slug: 'intellectual-property',
  //   title: 'Intellectual Property',
  //   shortTitle: 'IP Protection',
  //   tagline: 'Safeguarding Your Most Valuable Assets',
  //   heroDescription: 'Our IP team protects your innovations, brands, and creative works across Saudi Arabia and the GCC region through strategic registration, enforcement, and advisory services.',
  //   heroImage: 'https://images.unsplash.com/photo-1593444285553-28163240e3f1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbnRlbGxlY3R1YWwlMjBwcm9wZXJ0eSUyMHRyYWRlbWFyayUyMHBhdGVudHxlbnwxfHx8fDE3NzE1NjY2MDV8MA&ixlib=rb-4.1.0&q=80&w=1080',
  //   heroStats: [
  //     { value: '1,500+', label: 'IP Registrations' },
  //     { value: '100%', label: 'Enforcement Success' },
  //     { value: '30+', label: 'Industries Covered' },
  //   ],
  //   overview: 'In today\'s knowledge economy, intellectual property is often a company\'s most valuable asset. Saudi Arabia has made significant strides in strengthening its IP protection framework, aligning with international standards through WIPO membership and the GCC Patent Office. Our IP practice provides comprehensive protection for trademarks, patents, copyrights, trade secrets, and other intellectual property rights.',
  //   overviewPoints: [
  //     'Trademark registration and portfolio management',
  //     'Patent prosecution and protection',
  //     'Copyright registration and enforcement',
  //     'Trade secret protection strategies',
  //     'IP due diligence for transactions',
  //     'Anti-counterfeiting and brand protection',
  //   ],
  //   offerings: [
  //     {
  //       title: 'Trademark Services',
  //       description: 'Comprehensive trademark services including searches, registration, portfolio management, renewal, and opposition proceedings in Saudi Arabia and the GCC.',
  //     },
  //     {
  //       title: 'Patent Protection',
  //       description: 'Patent prosecution before the Saudi Authority for Intellectual Property and the GCC Patent Office, including prior art searches and patent strategy.',
  //     },
  //     {
  //       title: 'IP Enforcement',
  //       description: 'Vigorous enforcement of IP rights through administrative complaints, customs seizures, and court proceedings against infringers and counterfeiters.',
  //     },
  //     {
  //       title: 'IP Strategy & Advisory',
  //       description: 'Developing comprehensive IP strategies aligned with your business objectives, including licensing, technology transfer, and portfolio optimization.',
  //     },
  //   ],
  //   processSteps: [
  //     { title: 'IP Audit & Strategy', description: 'We assess your existing intellectual property assets, identify unprotected innovations, and develop a comprehensive protection strategy aligned with your business goals.' },
  //     { title: 'Search & Clearance', description: 'Our team conducts thorough prior art and trademark searches to assess registrability and identify potential conflicts before filing applications.' },
  //     { title: 'Filing & Prosecution', description: 'We prepare and file registration applications with the relevant Saudi and GCC IP offices, managing all examination processes and responding to objections.' },
  //     { title: 'Registration & Protection', description: 'Upon successful registration, we set up monitoring systems, renewal calendars, and enforcement protocols to maintain and protect your IP portfolio.' },
  //   ],
  //   whyChooseUs: [
  //     {
  //       title: 'Registry Expertise',
  //       description: 'Deep familiarity with Saudi and GCC IP registries ensures efficient and successful registrations.',
  //     },
  //     {
  //       title: 'Enforcement Track Record',
  //       description: 'Proven success in IP enforcement actions, including landmark cases in trademark and patent protection.',
  //     },
  //     {
  //       title: 'International Coordination',
  //       description: 'Coordinated IP protection across multiple jurisdictions through our global network of IP specialists.',
  //     },
  //     {
  //       title: 'Commercial Integration',
  //       description: 'IP strategy integrated with your broader business objectives, including M&A, licensing, and market entry.',
  //     },
  //   ],
  //   faq: [
  //     {
  //       question: 'How long does trademark registration take in Saudi Arabia?',
  //       answer: 'The trademark registration process typically takes 6-12 months from filing to registration, depending on whether any objections or oppositions are filed. We manage the entire process and handle any challenges.',
  //     },
  //     {
  //       question: 'Can I register a patent in Saudi Arabia?',
  //       answer: 'Yes, patents can be filed either directly with the Saudi Authority for Intellectual Property or through the GCC Patent Office for regional protection. We advise on the best filing strategy for your invention.',
  //     },
  //     {
  //       question: 'What should I do if my IP is being infringed?',
  //       answer: 'We recommend acting quickly. Our team can assess your options, send cease and desist letters, file administrative complaints, and initiate court proceedings to stop infringement and recover damages.',
  //     },
  //   ],
  //   relatedServices: ['contract-drafting-support', 'digital-data-protection', 'commercial-corporate-litigation'],
  // },
  // {
  //   slug: 'financial-crimes',
  //   title: 'Financial Crimes',
  //   shortTitle: 'Financial Crimes',
  //   tagline: 'Defending Against Financial Crime Allegations',
  //   heroDescription: 'Our financial crimes team provides expert defense and advisory services for clients facing allegations of financial misconduct, fraud, and regulatory violations.',
  //   heroImage: 'https://images.unsplash.com/photo-1705056508589-a87485825dc1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBjcmltZXMlMjBmcmF1ZCUyMGludmVzdGlnYXRpb258ZW58MXx8fHwxNzcxNTY2NjA2fDA&ixlib=rb-4.1.0&q=80&w=1080',
  //   heroStats: [
  //     { value: '200+', label: 'Investigations Handled' },
  //     { value: '98%', label: 'Acquittal Rate' },
  //     { value: 'SAR 1B+', label: 'Assets Protected' },
  //   ],
  //   overview: 'Financial crime allegations can threaten the very existence of a business and the liberty of individuals. Saudi Arabia has significantly strengthened its anti-financial crime framework, including enhanced anti-money laundering regulations, anti-fraud measures, and anti-corruption laws. Our financial crimes practice provides expert defense, investigation support, and compliance advisory to help clients navigate this complex and high-stakes area.',
  //   overviewPoints: [
  //     'Anti-money laundering (AML) compliance and defense',
  //     'Fraud investigation and defense',
  //     'Anti-corruption and bribery matters (FCPA/UKBA)',
  //     'Securities fraud and market manipulation',
  //     'Tax evasion defense',
  //     'Regulatory investigations and enforcement actions',
  //   ],
  //   offerings: [
  //     {
  //       title: 'Criminal Defense',
  //       description: 'Vigorous defense representation for individuals and corporations facing financial crime allegations before Saudi criminal courts and regulatory tribunals.',
  //     },
  //     {
  //       title: 'Internal Investigations',
  //       description: 'Conducting confidential internal investigations into suspected financial misconduct, providing reports and recommendations for remediation.',
  //     },
  //     {
  //       title: 'AML/CFT Compliance',
  //       description: 'Designing and implementing anti-money laundering and counter-terrorism financing compliance programs that meet Saudi and international standards.',
  //     },
  //     {
  //       title: 'Regulatory Response',
  //       description: 'Managing responses to regulatory investigations, enforcement actions, and sanctions proceedings by SAMA, CMA, and other authorities.',
  //     },
  //   ],
  //   processSteps: [
  //     { title: 'Immediate Response', description: 'We provide rapid initial response — assessing the situation, preserving documents, advising on communications, and developing a preliminary defense strategy.' },
  //     { title: 'Investigation & Analysis', description: 'Our team conducts a thorough factual investigation, analyzes applicable laws and regulations, and identifies potential defenses and mitigating factors.' },
  //     { title: 'Defense & Representation', description: 'We represent you in all interactions with prosecutors and regulatory authorities, prepare comprehensive defense submissions, and advocate vigorously on your behalf.' },
  //     { title: 'Resolution & Compliance', description: 'We pursue the best possible outcome — whether acquittal, settlement, or reduced penalties — and implement compliance programs to prevent future issues.' },
  //   ],
  //   whyChooseUs: [
  //     {
  //       title: 'Specialized Expertise',
  //       description: 'Dedicated financial crimes specialists with deep knowledge of Saudi criminal and regulatory frameworks.',
  //     },
  //     {
  //       title: 'Prosecution Perspective',
  //       description: 'Team members with experience in prosecution provides unique insight into how cases are built and can be defended.',
  //     },
  //     {
  //       title: 'Confidential Approach',
  //       description: 'Strict confidentiality and discretion in handling sensitive financial crime matters.',
  //     },
  //     {
  //       title: 'Multi-Jurisdictional',
  //       description: 'Experience with cross-border financial crime matters involving multiple regulatory authorities and jurisdictions.',
  //     },
  //   ],
  //   faq: [
  //     {
  //       question: 'What should I do if I receive a regulatory investigation notice?',
  //       answer: 'Contact us immediately. Early legal intervention is critical in financial crime matters. We can help you understand the scope of the investigation, preserve relevant documents, and develop a response strategy.',
  //     },
  //     {
  //       question: 'Do you handle anti-corruption compliance?',
  //       answer: 'Yes, we design and implement comprehensive anti-corruption compliance programs, conduct risk assessments, provide training, and advise on specific transactions to ensure compliance with Saudi and international anti-corruption laws.',
  //     },
  //     {
  //       question: 'Can you conduct internal investigations?',
  //       answer: 'Yes, we regularly conduct privileged internal investigations into suspected financial misconduct, providing detailed findings and actionable recommendations while maintaining legal privilege.',
  //     },
  //   ],
  //   relatedServices: ['digital-data-protection', 'commercial-corporate-litigation', 'corporate-governance-services'],
  // },
  // {
  //   slug: 'digital-data-protection',
  //   title: 'Digital & Data Protection',
  //   shortTitle: 'Data Protection',
  //   tagline: 'Navigating the Digital Legal Landscape',
  //   heroDescription: 'We help organizations comply with Saudi Arabia\'s evolving data protection laws and digital regulations while enabling innovation and digital transformation.',
  //   heroImage: 'https://images.unsplash.com/photo-1768839720936-87ce3adf2d08?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwZGF0YSUyMHByb3RlY3Rpb24lMjBjeWJlcnNlY3VyaXR5fGVufDF8fHx8MTc3MTU2NjYwNnww&ixlib=rb-4.1.0&q=80&w=1080',
  //   heroStats: [
  //     { value: '100+', label: 'Compliance Frameworks' },
  //     { value: 'Zero', label: 'Data Breaches' },
  //     { value: '50+', label: 'Companies Protected' },
  //   ],
  //   overview: 'Saudi Arabia\'s Personal Data Protection Law (PDPL) and related digital regulations represent a significant shift in the Kingdom\'s approach to data governance and digital rights. As businesses increasingly rely on digital infrastructure and data-driven decision-making, compliance with these evolving regulations is both a legal requirement and a competitive advantage. Our digital and data protection practice helps organizations navigate this complex landscape.',
  //   overviewPoints: [
  //     'Personal Data Protection Law (PDPL) compliance',
  //     'Data processing agreements and privacy policies',
  //     'Cross-border data transfer mechanisms',
  //     'Cybersecurity law compliance (NCA requirements)',
  //     'E-commerce and digital platform regulations',
  //     'Data breach response and notification',
  //   ],
  //   offerings: [
  //     {
  //       title: 'PDPL Compliance Programs',
  //       description: 'Comprehensive data protection compliance programs including gap analysis, policy development, data mapping, and implementation roadmaps.',
  //     },
  //     {
  //       title: 'Privacy Impact Assessments',
  //       description: 'Conducting Data Protection Impact Assessments (DPIAs) for high-risk processing activities and new technology implementations.',
  //     },
  //     {
  //       title: 'Cybersecurity Advisory',
  //       description: 'Advising on compliance with National Cybersecurity Authority (NCA) requirements, including framework implementation and incident response planning.',
  //     },
  //     {
  //       title: 'Data Breach Response',
  //       description: 'Rapid response support for data security incidents, including breach assessment, regulatory notification, affected party communication, and remediation.',
  //     },
  //   ],
  //   processSteps: [
  //     { title: 'Data Landscape Assessment', description: 'We map your data processing activities, identify personal data flows, assess current compliance levels, and pinpoint areas requiring immediate attention.' },
  //     { title: 'Gap Analysis & Roadmap', description: 'Our team compares your practices against PDPL and NCA requirements, then develops a prioritized compliance roadmap with clear milestones and timelines.' },
  //     { title: 'Policy & Framework Development', description: 'We design and implement privacy policies, data processing agreements, consent mechanisms, and cybersecurity frameworks tailored to your operations.' },
  //     { title: 'Training & Implementation', description: 'We conduct staff training, deploy compliance tools, establish incident response protocols, and ensure your organization is fully prepared for regulatory scrutiny.' },
  //     { title: 'Ongoing Monitoring & Support', description: 'We provide continuous compliance support, periodic audits, regulatory update briefings, and 24/7 data breach response capability.' },
  //   ],
  //   whyChooseUs: [
  //     {
  //       title: 'Regulatory Expertise',
  //       description: 'Deep understanding of PDPL, NCA requirements, and the evolving Saudi digital regulatory landscape.',
  //     },
  //     {
  //       title: 'Technical Understanding',
  //       description: 'Our team combines legal expertise with technical understanding of data systems and cybersecurity.',
  //     },
  //     {
  //       title: 'Practical Compliance',
  //       description: 'We design compliance solutions that work with your business operations, not against them.',
  //     },
  //     {
  //       title: 'Incident Ready',
  //       description: '24/7 availability for data breach response, ensuring rapid and compliant incident management.',
  //     },
  //   ],
  //   faq: [
  //     {
  //       question: 'Does the PDPL apply to my organization?',
  //       answer: 'The PDPL applies to any organization that processes personal data of individuals in Saudi Arabia, regardless of where the organization is based. This includes employee data, customer data, and any other personal information.',
  //     },
  //     {
  //       question: 'Can we transfer personal data outside Saudi Arabia?',
  //       answer: 'Cross-border data transfers are permitted under specific conditions, including adequacy determinations, appropriate safeguards, or consent. We advise on the available mechanisms for your specific data flows.',
  //     },
  //     {
  //       question: 'What are the penalties for non-compliance with PDPL?',
  //       answer: 'Penalties can include fines up to SAR 5 million, imprisonment in serious cases, and potential compensation claims from affected individuals. Compliance is essential to avoid these significant consequences.',
  //     },
  //   ],
  //   relatedServices: ['intellectual-property', 'financial-crimes', 'corporate-governance-services'],
  // },


];

export const getServiceBySlug = (slug: string): ServiceData | undefined => {
  return services.find(s => s.slug === slug);
};

export const getRelatedServices = (slugs: string[]): ServiceData[] => {
  return slugs.map(slug => services.find(s => s.slug === slug)).filter(Boolean) as ServiceData[];
};
